import axios from './axios';


export const getProductDetail = async (id) => {
    try {
        const response = await axios.get(`/product/detail?id=${id}`);
        return response;  
    } catch (error) {
        return error.response;  
    }
};
// getRelatesPro
export const getRelatesPro = async (id,page,per_page) => {
    try {
        const response = await axios.get(`/product/related?id=${id}&page=${page}&per_page=${per_page}`);
        return response;  
    } catch (error) {
        return error.response;  
    }
};
// fetchProducts
export const fetchProducts = async (query) => {
    try {
        const response = await axios.get(`/product/list?${query}`);
        return response;  
    } catch (error) {
        return error.response;  
    }
};


